import { useEffect, useState } from 'react';

import { useDocumentChatContext } from '@/modules/chat/contexts/DocumentChatProvider';
import { ChatComposer } from '@/modules/common/Chat/components/ChatComposer';

export function DocumentChatComposer() {
  const [message, setMessage] = useState('');
  const { askQuestion, awaitingFirstToken, error, lastUserMessage } =
    useDocumentChatContext();

  // Populate the input with the last user message when there's an error.
  // Clear the input again once the failed state has been cleared.
  useEffect(() => {
    if (error && lastUserMessage) {
      setMessage(lastUserMessage);
    } else if (!error) {
      setMessage('');
    }
  }, [error, lastUserMessage]);

  return (
    <ChatComposer
      buttonLabel="Ask"
      disabled={awaitingFirstToken}
      onSubmit={askQuestion}
      onValueChange={setMessage}
      placeholder="Ask a question..."
      value={message}
    />
  );
}
